import { render, staticRenderFns } from "./SelectOfPropertiesByReference.vue?vue&type=template&id=30cf0eee&"
import script from "./SelectOfPropertiesByReference.vue?vue&type=script&lang=js&"
export * from "./SelectOfPropertiesByReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports